export const customOptionValue = "custom";

export const attendantTitles = [
  {
    text: "Matron of Honor",
    value: "Matron of Honor",
  },
  {
    text: "Maid of Honor",
    value: "Maid of Honor",
  },
  {
    text: "Best Man",
    value: "Best Man",
  },
  {
    text: "Bridesmaid",
    value: "Bridesmaid",
  },
  {
    text: "Groomsman",
    value: "Groomsman",
  },
  {
    text: "Father of the Bride",
    value: "Father of the Bride",
  },
  {
    text: "Father of the Groom",
    value: "Father of the Groom",
  },
  {
    text: "Mother of the Bride",
    value: "Mother of the Bride",
  },
  {
    text: "Mother of the Groom",
    value: "Mother of the Groom",
  },
  {
    text: "Honor Attendants",
    value: "Honor Attendants",
  },
  {
    text: "Candle Lighter",
    value: "Candle Lighter",
  },
  {
    text: "Flower Girl/Child",
    value: "Flower Girl/Child",
  },
  {
    text: "Ring Bearer",
    value: "Ring Bearer",
  },
  {
    text: "Officiant",
    value: "Officiant",
  },
  {
    text: "Usher",
    value: "Usher",
  },
];

export const attendantTitlesWithCustom = [
  {
    text: "Custom",
    value: customOptionValue,
  },
  ...attendantTitles,
];

export const ATTENDANT_PLACEHOLDER_DESCRIPTIONS = {
  "Best Man":
    "[Name] has been an incredible friend and a trusted confidant. His unwavering support means the world to me, and I’m honored to have [Name] by my side on this special day as my best man.",
  Bridesmaid:
    "[Name] is a true friend and an important part of my life. I’m so thankful to have her as a bridesmaid on our wedding day.",
  "Candle Lighter":
    "[Name] will help light the candles that symbolize the joining of two families. Their role is a meaningful one, and we’re so thankful to have [Name] take part.",
  custom: "Description",
  "Father of the Bride":
    "My dad’s love and support mean everything to me. I’m very lucky to have him by my side as we take this next step in life.",
  "Father of the Groom":
    "My father has shaped me into the man I am today. It’s an honor to have him with us as we begin this chapter of our lives.",
  "Flower Girl/Child":
    "[Name], the cutest addition to our wedding, will walk down the aisle spreading joy—and flower petals. We’re lucky to have [Name] help make this moment special.",
  Groomsman:
    "[Name] has always had my back, and I’m proud to have him standing with me as a groomsman as I take the leap.",
  "Honor Attendants":
    "[Name] has supported us through life’s ups and downs, offering love and encouragement all along the way. We're so grateful to have [Name] as an honor attendant.",
  "Maid of Honor":
    "[Name] has been by my side since [insert shared memory]. She’s my best friend and one of the best people I know. I couldn’t imagine this day without her, and I’m beyond grateful to have [Name] as my maid of honor.",
  "Matron of Honor":
    "[Name] has been by my side since [insert shared memory]. She's my best friend and one of the best people I know. I couldn't imagine this day without her, and I'm beyond grateful to have [Name] as my matron of honor.",
  "Mother of the Bride":
    "To know my mom is to love her. I’m beyond thankful for her guidance, her wisdom, and all the ways she’s helped make this day possible.",
  "Mother of the Groom":
    "My mom has been a constant source of love and encouragement, and I’m delighted to have her by my side on this beautiful day.",
  Officiant:
    "We are honored to have [Name] guiding us through our vows and officiating our ceremony.",
  "Ring Bearer":
    "[Name] has the important job of carrying the rings down the aisle. We’re so glad [Name] will be carrying out this tradition for us. ",
  Usher:
    "[Name] will be there to greet our guests and help everyone find their seat. We truly appreciate their support in making the day run smoothly.",
};
